import styled from 'styled-components';

export const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 450px;
  margin: 0 auto;
  padding: clamp(24px, 5vw, 40px);
  background: #fff;
  border-radius: 16px;
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;

  @media (max-width: 480px) {
    border-radius: 12px;
  }
`;

export const Title = styled.h1`
  font-size: 24px;
  color: ${({ theme }) => theme.colors.gray[900]};
  margin-bottom: 32px;
`;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Input = styled.input`
  width: 100%;
  height: 52px;
  padding: 0 16px;
  background: #fff;
  border: 2px solid ${({ theme }) => theme.colors.gray[100]};
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.2s ease-in;
  outline: none;

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary.main};
  }
`;

export const CapsLockHint = styled.span`
  display: block;
  margin-top: 6px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors?.warning?.main || '#b45309'};
`;

export { Button } from '../shared/Button';

export const Footer = styled.div`
  margin-top: 24px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.gray[900]};

  button {
    background: none;
    border: none;
    color: ${({ theme }) => theme.colors.primary.main};
    font-weight: bold;
    cursor: pointer;
    margin-left: 4px;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;
